import { Link } from "react-router-dom";
import { money } from "@/lib/api";
import { Bed, Bath, MapPin, Maximize } from "lucide-react";

export default function PropertyCard({ property, index = 0 }) {
  const img = property.images?.[0] || "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=85";
  return (
    <Link
      to={`/property/${property.id}`}
      data-testid={`property-card-${property.id}`}
      className="group block bg-white border border-line rounded-xl overflow-hidden shadow-[0_2px_8px_rgba(26,26,26,0.04)] hover:shadow-[0_8px_24px_rgba(26,26,26,0.10)] hover:-translate-y-1 transition-all duration-300 animate-fade-up opacity-0"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-bone">
        <img
          src={img}
          alt={property.title}
          className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 bg-white/95 backdrop-blur text-forest text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full capitalize">
          {property.property_type}
        </span>
      </div>
      <div className="p-5">
        <div className="flex items-baseline justify-between gap-2">
          <h3 className="font-heading font-medium text-ink text-lg leading-tight truncate">{property.title}</h3>
        </div>
        <div className="flex items-center gap-1 text-mute text-sm mt-1">
          <MapPin className="h-3.5 w-3.5" strokeWidth={1.75} />
          <span className="truncate">{property.city}, {property.state}</span>
        </div>
        <div className="flex items-center gap-4 mt-4 text-sm text-ink">
          <span className="flex items-center gap-1.5"><Bed className="h-4 w-4 text-forest" strokeWidth={1.75} />{property.bedrooms}</span>
          <span className="flex items-center gap-1.5"><Bath className="h-4 w-4 text-forest" strokeWidth={1.75} />{property.bathrooms}</span>
          {property.square_feet > 0 && (
            <span className="flex items-center gap-1.5"><Maximize className="h-4 w-4 text-forest" strokeWidth={1.75} />{property.square_feet} ft²</span>
          )}
        </div>
        <div className="mt-4 pt-4 border-t border-line flex items-baseline gap-1">
          <span className="font-heading font-semibold text-xl text-forest">{money(property.monthly_rent)}</span>
          <span className="text-sm text-mute">/month</span>
        </div>
      </div>
    </Link>
  );
}
